import React from "react";
import './App.css';

export const Favorites = () => {
    return (
        <div>
            <h1 className="favorites">Favorites will go here</h1>
        </div>
    )
}